var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88484471,-7.10542736e-15 C10.2446055,-7.10542736e-15 12.1575695,2.04049499 12.1575695,4.55757313 C12.1575695,5.63080301 11.8097941,6.61739043 11.2278938,7.39610808 L11.0208006,7.32508374 C13.3201837,8.07324219 14.9323883,9.69866464 15.0035954,11.5961631 L15.0060527,11.7272752 L15.0060527,14.8606067 C15.0060527,15.4612731 14.5412499,15.9533789 13.9516937,15.9968748 L13.8666594,16 L2.47272662,16 C1.87206024,16 1.37995439,15.5351972 1.33645854,14.945641 L1.33333333,14.8606067 L1.33333333,11.7272752 C1.33333333,9.95733891 2.67390731,8.40918734 4.67506997,7.56447673 C4.01317147,6.76267092 3.6121199,5.71007969 3.6121199,4.55757313 C3.6121199,2.04049499 5.52508396,-7.10542736e-15 7.88484471,-7.10542736e-15 Z M10.3193563,8.30266547 C9.62404874,8.8168386 8.78710617,9.11514626 7.88484471,9.11514626 C7.05365036,9.11514626 6.27789039,8.86198063 5.62163961,8.42399584 C3.78180096,9.03452001 2.53747819,10.2763888 2.47517864,11.6214223 L2.47272662,11.7272752 L2.47272662,14.8606067 L13.8666594,14.8606067 L13.8666594,11.7272752 C13.8666594,10.2464576 12.4261308,8.87315622 10.3193563,8.30266547 Z M7.88484471,1.13939328 C6.17137747,1.13939328 4.75151318,2.65391519 4.75151318,4.55757313 C4.75151318,6.46123107 6.17137747,7.97575298 7.88484471,7.97575298 C9.59831195,7.97575298 11.0181762,6.46123107 11.0181762,4.55757313 C11.0181762,2.65391519 9.59831195,1.13939328 7.88484471,1.13939328 Z",
    id: "Combined-Shape-Copy-15",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.92504c86c507b3ef206ff29ea28b46cd.svg";
export { ForwardRef as ReactComponent };